import common from '@material-ui/core/colors/common';
import red from '@material-ui/core/colors/red';
const white = common.white;
const red500 = red['500'];
// import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";
import {cardTitle} from '../../../assets/jss/material-dashboard-pro-react.jsx'
 
const billingStyles = theme => ({
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px",
        "& small": {
            fontSize: "80%",
            fontWeight: "400"
        }
    },
    pageTitle: {
        background: '#FFFFFF',
        border: '1px solid rgba(0, 0, 0, 0.13)',
        boxSizing: 'border-box',
        borderRadius: '5px',
        padding: '10px',
        marginBottom: '20px'
    },
    labelHorizontal: {
        cursor: "pointer",
        display: "inline-flex",
        fontSize: "14px",
        fontWeight: "400",
        marginRight: "0",
        lineHeight: "20px",
        "@media (min-width: 992px)": {
            textAlign: "end",
            float: "right"
        }
    },
    labelAndText: {
        lineHeight: "1.428571429",
        paddingTop: "15px",
    },
    tableCell: {
        fontSize: '14px',
        borderRight: '1px solid rgba(0, 0, 0, 0.08)'
    },
    tableRow: {
        '& th:last-child': {
            borderRight: 'none',
        }
    },
    tableContainer: {
        overflowX: 'auto', 
        borderRadius: '0px 0px 5px 5px',
        borderRight: '1px solid rgba(0, 0, 0, 0.13)',
        borderLeft: '1px solid rgba(0, 0, 0, 0.13)',
    },
    billingContainer: {
        marginBottom: '50px'
    },
    billingContainerHeader: {
        background: '#F8F8F8',
        border: '1px solid rgba(0, 0, 0, 0.13)',
        boxSizing: 'border-box',
        borderRadius: '5px 5px 0px 0px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        padding: '5px 10px'
    },
    addBtn: {
        background: '#00CD6B',
        boxShadow: '4px 4px 18px 1px rgba(0, 205, 107, 0.35)',
        padding: '10px 20px',
        borderRadius: '3px', 
        color: '#fff', 
        outline: 'none', 
        border: '1px solid', 
        borderImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(27, 97, 237, 0) 100%) 1 stretch',
        "&:after": {
            content: "'Add'"
        }
    },
    editBtn: {
        background: '#fff',
        border: '3px solid', 
        color: '#1B23ED',
        outline: 'none', 
        borderRadius: '3px',
        padding: '10px 20px',
        borderImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(185, 0, 44, 0) 100%), linear-gradient(0deg, #1B23ED, #1B23ED) 1 strech',
        "&:after": {
            content: "'Edit'"
        }
    },
    emptyBillingDetailsContainer: {
        background: '#FFFFFF',
        minHeight: '100px',
        border: '1px solid rgba(0, 0, 0, 0.13)',
        boxSizing: 'border-box',
        borderRadius: '0px 0px 5px 5px', padding: '5px 10px'
    }
});

export default billingStyles;



// WEBPACK FOOTER //
// ./src/containers/billing/jss/BillingStyles.js